// Sealed-cards filter options. Tri-state select that replaced the old boolean toggle.
// The selected value is sent verbatim as the `sealed` query param (explicit selection,
// mirrored by the API's SEALED_FILTER_VALUES enum):
// - WITHOUT_SEALED (default) → `sealed=withoutSealed` → exclude sealed cards
// - SEALED_ONLY               → `sealed=sealedOnly`    → only sealed cards
// - WITH_SEALED               → `sealed=withSealed`    → all cards (sealed + unsealed)
export const SEALED_FILTER_OPTIONS = {
  WITHOUT_SEALED: 'withoutSealed',
  SEALED_ONLY: 'sealedOnly',
  WITH_SEALED: 'withSealed',
};

export const DEFAULT_SEALED_FILTER = SEALED_FILTER_OPTIONS.WITHOUT_SEALED;
